import React, { useEffect } from "react";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { getActivePackages } from "../../../../redux/api/expedition.api";
import TableWidget from "../../../../components/tables/TableWidget";
import {
  activePackagesTableHeader,
  getActivePackagesTableData,
} from "./tableConfigs/activePackagesTableConfig";

function ActivePackages() {
  const dispatch = useAppDispatch();

  const {
    expedition: {
      activePackages: {
        data: { data: activePackagesData, total: totalActivePackages },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  const { routeParams } = useRoutesHelper();
  const { idExpeditie, client } = routeParams || {};

  useEffect(() => {
    if (idExpeditie) {
      dispatch(
        getActivePackages({
          id_doctrans: idExpeditie,
          perPage: 9999,
        }),
      );
    }
  }, [dispatch, idExpeditie]);

  return (
    <TableWidget
      tableTitle={`Colete active pentru clientul ${client}`}
      tableHeaderData={activePackagesTableHeader}
      tableItemsData={getActivePackagesTableData(activePackagesData)}
      totalItems={totalActivePackages}
      tableLoading={isLoading}
      withTablePagination={false}
    />
  );
}

export default ActivePackages;
